import axios from "./index";

export default {
  getAll() {
    return axios.get("/v1/setting/offices");
  },
  getDropdown() {
    return axios.get("/v1/setting/offices/dropdown");
  },
  create(data) {
    return axios.post("/v1/setting/offices", data);
  },
  update(uuid, data) {
    return axios.patch(`/v1/setting/offices/${uuid}`, data);
  },
};
